import { Task } from 'src/facade/tasks/tasksService.types'

const ATTRIBUTE_DOCUMENT_NUMBER_PREFIX: string = 'Document Number'

export function getDocumentNumber(task: Task): string | undefined {
	return Object.entries(task.main_asset.attribute ?? {}).find(([attributeName]) =>
		attributeName.startsWith(ATTRIBUTE_DOCUMENT_NUMBER_PREFIX),
	)?.[1] as string
}
